import { render, staticRenderFns } from "./SettingsMnemonicConfirm.vue?vue&type=template&id=39e4fac7&scoped=true"
import script from "./SettingsMnemonicConfirm.vue?vue&type=script&lang=js"
export * from "./SettingsMnemonicConfirm.vue?vue&type=script&lang=js"
import style0 from "./SettingsMnemonicConfirm.vue?vue&type=style&index=0&id=39e4fac7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e4fac7",
  null
  
)

export default component.exports